import activityFinishedImg from './images/activity-finished.svg';
import addListImg from './images/add-list.svg';
import booksImg from './images/books.svg';
import brokenImg from './images/broken.png';
import finishedImg from './images/finished.svg';
import goalAccomplishedImg from './images/goal-accomplished.svg';
import horizontalLogoImg from './images/horizontal-logo.svg';
import iconImg from './images/icon.png';
import lockImg from './images/lock.svg';
import moonImg from './images/moon.svg';
import officeImg from './images/office.svg';
import restImg from './images/rest.svg';
import sleepingImg from './images/sleeping.svg';
import trophyImg from './images/trophy.svg';
import welcomeImg from './images/welcome.svg';
import womanImg from './images/woman.svg';
import wipImg from './images/wip.svg';
import ScreensBackgroundImg from './images/screens-background.png';
import InviteFriendsImg from './images/invite-friends.svg';
import ReclassificationTreeImg from './images/reclassification-tree.svg';
import doctorSpeakImg from './images/doctor-speak.svg';

import agendaMenuImg from './images/icons/agendamenu.svg';
import agendaMenuWhiteImg from './images/icons/agendamenu-white.svg';
import levelingImg from './images/icons/leveling.svg';
import levelingWhiteImg from './images/icons/leveling-white.svg';
import noNotificationImg from './images/icons/no-notification.svg';
import searchImg from './images/icons/search.svg';
import startImg from './images/icons/star.svg';

import ob1Img from './images/onboarding/ob1.svg';
import ob2Img from './images/onboarding/ob2.svg';
import ob3Img from './images/onboarding/ob3.svg';
import ob4Img from './images/onboarding/ob4.svg';
import ob5Img from './images/onboarding/ob5.svg';
import ob6Img from './images/onboarding/ob6.svg';
import ob7Img from './images/onboarding/ob7.svg';
import ob8Img from './images/onboarding/ob8.svg';
import ob9Img from './images/onboarding/ob9.svg';
import ob10Img from './images/onboarding/ob10.svg';
import ob11Img from './images/onboarding/ob11.svg';
import ob12Img from './images/onboarding/ob12.svg';

import rochaImg from './images/met-medq/rocha.svg';
import advertsImg from './images/met-medq/adverts.svg';
import influencersImg from './images/met-medq/influencers.svg';
import friendsImg from './images/met-medq/friends.svg';

import agendaBlueImg from './icons/agenda-blue.svg';
import agendaSuccessImg from './icons/agenda-success.svg';
import agendaWarningImg from './icons/agenda-warning.svg';
import bookImg from './icons/book.svg';
import chartBarSecondary4Img from './icons/chart-bar-secondary4.svg';
import chartLineImg from './icons/chart-line.svg';
import chartLineSecondary4Img from './icons/chart-line-secondary4.svg';
import chartPizzaImg from './icons/chart-pizza.svg';
import checkImg from './icons/check.svg';
import commentDotsDarkGrayImg from './icons/comment-dots-dark-gray.svg';
import communityBlueImg from './icons/community-blue.svg';
import communityWhiteImg from './icons/community-white.svg';
import coursesImg from './icons/courses.svg';
import examsImg from './icons/exams.svg';
import examsSecondary2Img from './icons/exams-secondary2.svg';
import extraActivitiesImg from './icons/extra-activities.svg';
import extraActivitiesSecondary4Img from './icons/extra-activities-secondary4.svg';
import facebookImg from './icons/facebook.svg';
import flashcardOutlinedImg from './icons/flashcard-outlined.svg';
import flashcardsImg from './icons/flashcards.svg';
import flashcardsSecondary2Img from './icons/flashcards-secondary2.svg';
import googleImg from './icons/google.svg';
import historicImg from './icons/historic.svg';
import historicSuccessImg from './icons/historic-success.svg';
import historicWarningImg from './icons/historic-warning.svg';
import incidenceBlueImg from './icons/incidence-blue.svg';
import incidenceSuccessImg from './icons/incidence-success.svg';
import incidenceWarningImg from './icons/incidence-warning.svg';
import livroImg from './icons/livro.svg';
import mailImg from './icons/mail.svg';
import medalImg from './icons/medal.svg';
import menuAgendaImg from './icons/menu-agenda.svg';
import menuAssuntosImg from './icons/menu-assuntos.svg';
import menuComunidadeImg from './icons/menu-comunidade.svg';
import menuHomeImg from './icons/menu-home.svg';
import menuPerfilImg from './icons/menu-perfil.svg';
import menuProvasImg from './icons/menu-provas.svg';
import resumeImg from './icons/resume.svg';
import resumeSecondary2Img from './icons/resume-secondary2.svg';
import shapesSecondary2Img from './icons/shapes-secondary2.svg';
import simuladoImg from './icons/simulado.svg';
import testImg from './icons/test.svg';
import trophyIconDarkGrayImg from './icons/trophy-icon-dark-gray.svg';

import rewardHeaderImg from './images/activities/reward-header.svg';
import igCircleImg from './images/activities/ig.svg';
import zapCircleImg from './images/activities/zap.svg';
import mailCircleImg from './images/activities/mail.svg';

export const activityFinished = activityFinishedImg;
export const addList = addListImg;
export const books = booksImg;
export const broken = brokenImg;
export const finished = finishedImg;
export const goalAccomplished = goalAccomplishedImg;
export const horizontalLogo = horizontalLogoImg;
export const icon = iconImg;
export const lock = lockImg;
export const moon = moonImg;
export const office = officeImg;
export const rest = restImg;
export const sleeping = sleepingImg;
export const trophy = trophyImg;
export const welcome = welcomeImg;
export const woman = womanImg;
export const wip = wipImg;
export const screensBackground = ScreensBackgroundImg;
export const inviteFriends = InviteFriendsImg;

export const agendaMenu = agendaMenuImg;
export const agendaMenuWhite = agendaMenuWhiteImg;
export const leveling = levelingImg;
export const levelingWhite = levelingWhiteImg;
export const noNotification = noNotificationImg;
export const search = searchImg;
export const start = startImg;

export const ob1 = ob1Img;
export const ob2 = ob2Img;
export const ob3 = ob3Img;
export const ob4 = ob4Img;
export const ob5 = ob5Img;
export const ob6 = ob6Img;
export const ob7 = ob7Img;
export const ob8 = ob8Img;
export const ob9 = ob9Img;
export const ob10 = ob10Img;
export const ob11 = ob11Img;
export const ob12 = ob12Img;

export const rocha = rochaImg;
export const adverts = advertsImg;
export const influencers = influencersImg;
export const friends = friendsImg;

export const agendaBlue = agendaBlueImg;
export const agendaSuccess = agendaSuccessImg;
export const agendaWarning = agendaWarningImg;
export const book = bookImg;
export const chartBarSecondary4 = chartBarSecondary4Img;
export const chartLine = chartLineImg;
export const chartLineSecondary4 = chartLineSecondary4Img;
export const chartPizza = chartPizzaImg;
export const check = checkImg;
export const commentDotsDarkGray = commentDotsDarkGrayImg;
export const communityBlue = communityBlueImg;
export const communityWhite = communityWhiteImg;
export const courses = coursesImg;
export const exams = examsImg;
export const examsSecondary2 = examsSecondary2Img;
export const extraActivities = extraActivitiesImg;
export const extraActivitiesSecondary4 = extraActivitiesSecondary4Img;
export const facebook = facebookImg;
export const flashcardOutlined = flashcardOutlinedImg;
export const flashcards = flashcardsImg;
export const flashcardsSecondary2 = flashcardsSecondary2Img;
export const google = googleImg;
export const historic = historicImg;
export const historicSuccess = historicSuccessImg;
export const historicWarning = historicWarningImg;
export const incidenceBlue = incidenceBlueImg;
export const incidenceSuccess = incidenceSuccessImg;
export const incidenceWarning = incidenceWarningImg;
export const livro = livroImg;
export const mail = mailImg;
export const medal = medalImg;
export const menuAgenda = menuAgendaImg;
export const menuAssuntos = menuAssuntosImg;
export const menuComunidade = menuComunidadeImg;
export const menuHome = menuHomeImg;
export const menuPerfil = menuPerfilImg;
export const menuProvas = menuProvasImg;
export const resume = resumeImg;
export const resumeSecondary2 = resumeSecondary2Img;
export const shapesSecondary2 = shapesSecondary2Img;
export const simulado = simuladoImg;
export const test = testImg;
export const trophyIconDarkGray = trophyIconDarkGrayImg;
export const reclassificationTree = ReclassificationTreeImg;
export const doctorSpeak = doctorSpeakImg;

export const rewardHeader = rewardHeaderImg;
export const igCircle = igCircleImg;
export const zapCircle = zapCircleImg;
export const mailCircle = mailCircleImg;
